// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"20":"6f868db6","320":"d228d505"}[chunkId] + ".js";
};